import { buildVarStyle, styleText } from "../style";
import type { WidgetConfig } from "./config";

let mountPoint: HTMLDivElement | null = null;
let varStyleEl: HTMLStyleElement | null = null;

export function getModalMountPoint(config: WidgetConfig): HTMLElement {
  if (!mountPoint) {
    const host = document.createElement("div");
    host.setAttribute("data-gitg-modal-host", "");
    host.style.cssText =
      "position: fixed; inset: 0; z-index: 2147483647; pointer-events: none;";
    document.body.appendChild(host);

    const shadow = host.attachShadow({ mode: "open" });
    varStyleEl = document.createElement("style");
    const style = document.createElement("style");
    style.textContent = styleText;
    mountPoint = document.createElement("div");
    mountPoint.style.cssText = "pointer-events: auto;";
    shadow.append(varStyleEl, style, mountPoint);
  }
  if (varStyleEl) varStyleEl.textContent = buildVarStyle(config);
  return mountPoint;
}
